import { Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneButton from "../../../../Components/OneButton/OneButton"
import { sxTopoCriarEncomenda } from "./CriarEncomenda"
import { useState } from "react"
import OneModal from "../../../../Components/OneModal/OneModal"
import EntregaMultipla from "../ListaEntregas/EntregaMultipla/EntregaMultipla"
import NovaEntrega from "../ListaEntregas/NovaEntrega/NovaEntrega"
import box1 from '../../../../Assets/icones/box1.svg'
import { Add } from "@mui/icons-material"

const CriarEncomenda = () => {
    const [openModalNovaEntrega, setOpenModalNovaEntrega] = useState(false)
    const [openModalEntregaMultipla, setOpenModalEntregaMultipla] = useState(false)

    const handleEntregaMultipla = () => {
        setOpenModalEntregaMultipla(true)
    }
    const handleNovaEntrega = () => {
        setOpenModalNovaEntrega(true)
    }
    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} container sx={{ justifyContent: 'space-between', alignItems: 'center' }}>

            <Grid xs={12} sm={4} md={4} lg={4} xl={6} sx={sxTopoCriarEncomenda}>
                <img src={box1}></img>
                <Typography sx={{ color: 'black', fontWeight: '600', fontSize: '16px' }}>Entregas Registradas</Typography>
            </Grid>

            <Grid xs={12} sm={8} md={8} lg={8} xl={6} sx={{ ...sxTopoCriarEncomenda, justifyContent: 'flex-end' }}>

                <OneButton
                    color="one_primary"
                    backgroundColor='true'
                    variant="contained"
                    onClick={handleEntregaMultipla}
                    IconStart={Add}
                    sxIconStart={{ width: '20px' }}
                    newSx={{ border: '0px' }}
                >
                    MULTIPLA ENTREGA
                </OneButton>

                <OneButton
                    color="one_primary"
                    backgroundColor='true' variant="contained"
                    onClick={handleNovaEntrega}
                    IconStart={Add}
                    sxIconStart={{ width: '20px' }}
                    newSx={{ border: '0px' }}
                >
                    NOVA ENTREGA
                </OneButton>

            </Grid>

            <OneModal
                open={openModalEntregaMultipla}
                setOpen={setOpenModalEntregaMultipla}
                titleText={'Entrega Multipla'}
                maxWidth="md"
                onClose={false}
            >
                <EntregaMultipla
                    openModalEntregaMultipla={openModalEntregaMultipla}
                    setOpenModalEntregaMultipla={setOpenModalEntregaMultipla}/>
            </OneModal>

            <OneModal
                open={openModalNovaEntrega}
                setOpen={setOpenModalNovaEntrega}
                titleText={'Nova Entrega'}
                fullWidth={true}
                onClose={false}
            >
                <NovaEntrega
                    setOpenModalNovaEntrega={setOpenModalNovaEntrega}
                    isModalOpen={openModalNovaEntrega}
                />
            </OneModal>

        </Grid>
    )
}

export default CriarEncomenda
